import { observer } from 'mobx-react-lite';

import { FilterDropdownMenu } from '@/components/ui/filter-dropdown-menu';

import { ROUTINE_FILTER_OPTION_GROUPS } from '../routine-filters';
import { routinesStore } from '../routines.state';

export const RoutineFilterMenu = observer(
  ({ compact = false }: { compact?: boolean }) => (
    <FilterDropdownMenu
      aria-label="Filter routines"
      allLabel="All routines"
      optionGroups={ROUTINE_FILTER_OPTION_GROUPS}
      selectedValues={[...routinesStore.useRoutineFilters()]}
      onToggle={(filter) => routinesStore.toggleRoutineFilter(filter)}
      onClearAll={() => routinesStore.clearRoutineFilters()}
      contentClassName="min-w-52"
      compact={compact}
    />
  )
);
